export { default } from './EventRegistration'



// WEBPACK FOOTER //
// ./src/App/pages/EventRegistration/index.js